export enum NodeTypes {
    CHALLENGE_NODE = "challengeNode",
    ACTIVITY_NODE = "activityNode",
    GATEWAY_NODE = "gatewayNode",
    START_NODE = "startNode",
    END_NODE = "endNode",
    INFO_NODE = "infoNode",
    GAMIFICATION_EVENT_NODE = "gamificationEventNode"
}